// 不同国家对应的不同类型

// 财务期间类型
export const financialPeriodTypeData = {
  Singapore: [
    {
      title: "12 months",
      value: "12 months",
    },
    {
      title: "52-week accounting period",
      value: "52-week accounting period",
    },
  ],
  Malaysia: [
    {
      title: "12 months",
      value: "12 months",
    },
  ],
};

// 证件类型
export const identificationTypeData = {
  Singapore: [
    {
      title: "NRIC (Citizen)",
      value: "NRIC (Citizen)",
    },
    {
      title: "NRIC (Permanent Resident)",
      value: "NRIC (Permanent Resident)",
    },
    {
      title: "FIN",
      value: "FIN",
    },
    {
      title: "Passport/Others",
      value: "Passport/Others",
    },
  ],
  Malaysia: [
    {
      title: "Military ID number",
      value: "Military ID number",
    },
    {
      title: "My Old IC number",
      value: "My Old IC number",
    },
    {
      title: "MyKad",
      value: "MyKad",
    },
    {
      title: "MyKAS",
      value: "MyKAS",
    },
    {
      title: "MyPR",
      value: "MyPR",
    },
    {
      title: "Non-citizen without passport number",
      value: "Non-citizen without passport number",
    },
    {
      title: "Official Receiver ID number",
      value: "Official Receiver ID number",
    },
    {
      title: "Passport number",
      value: "Passport number",
    },
    {
      title: "Police ID number",
      value: "Police ID number",
    },
  ],
};

// 实体类型
export const entityTypeData = {
  Malaysia: [
    {
      value: 1,
      title: "Local Entity",
    },
    {
      value: 2,
      title: "Foreign Entity",
    },
  ],
};

// 公司类型
export const companyTypeData = {
  Malaysia: [
    {
      value: "Bodies corporate controlled by citizens who are Malays and natives",
      title: "Bodies corporate controlled by citizens who are Malays and natives",
    },
    {
      value: "Bodies corporate controlled by citizens who are non-Malays and non-natives",
      title: "Bodies corporate controlled by citizens who are non-Malays and non-natives",
    },
    {
      value: "Bodies corporate controlled by non-citizens",
      title: "Bodies corporate controlled by non-citizens",
    },
  ],
};

// 种族类型
export const raceTypeData = {
  Malaysia: [
    {
      value: "BAJAU",
      title: "BAJAU",
    },
    {
      value: "BIDAYUH",
      title: "BIDAYUH",
    },
    {
      value: "BUMIPUTERA SABAH",
      title: "BUMIPUTERA SABAH",
    },
    {
      value: "BUMIPUTERA SARAWAK",
      title: "BUMIPUTERA SARAWAK",
    },
    {
      value: "CHINESE",
      title: "CHINESE",
    },
    {
      value: "DUSUN",
      title: "DUSUN",
    },
    {
      value: "FOREIGNER",
      title: "FOREIGNER",
    },
    {
      value: "IBAN",
      title: "IBAN",
    },
    {
      value: "INDIAN",
      title: "INDIAN",
    },
    {
      value: "KADAZAN",
      title: "KADAZAN",
    },
    {
      value: "MALAY",
      title: "MALAY",
    },
    {
      value: "MELANAU",
      title: "MELANAU",
    },
    {
      value: "NATIVE",
      title: "NATIVE",
    },
    {
      value: "ORANG ULU",
      title: "ORANG ULU",
    },
    {
      value: "OTHER RACE",
      title: "OTHER RACE",
    },
  ],
};

// 公司章程类型
export const customizedConstitutionTypeData = {
  Singapore: [
    {
      title: "Standard constitution",
      value: 0,
    },
    {
      title: "Customized constitution (customized constitution reviewed by legal is required to be uploaded in the next step under this option)",
      value: 1,
    },
  ],
  Malaysia: [
    {
      title: "No Constitution (Governed by the Companies Act 2016)",
      value: 0,
    },
    {
      title: "Customized constitution (customized constitution reviewed by local legal is required to be uploaded in the next step under this option)",
      value: 1,
    },
  ],
};
